// Layer order + token bridge + Tailwind tokens-only utilities: FIRST, so the cascade layers are declared before any other sheet.
import './index.css';
import { render } from 'preact';
import { initGoogleAuth } from './auth/google-auth';
import { App } from './components/App';
import { ReaderModeProvider } from './hooks/useReaderMode';
import { TtsProvider, ReaderTtsProvider } from './hooks/useTtsContext';
import { ReaderOverlay } from './components/ReaderMode/ReaderOverlay';
import { syncBratoThemeFromStorage } from './themeSync';
import { initSeWindow } from './state/seWindow';
import { getBrand } from './brands';
import './style.css';
import './styles/shell-token-remap.css';
import './styles/reader-mode.css';
import './styles/fonts-candidate.css';
import './next/fontFlag';

syncBratoThemeFromStorage();
// SE window seam (issue #2201) — installs window.__vaSe ONLY when ?vaSe=1 is present;
// inert in normal use. Runs before render so the handle exists before any effect reads it.
initSeWindow();

// Brand bootstrap — apply page title + accent CSS variable from VITE_BRAND.
// `--brand-accent` is consumed by Tailwind/CSS in components that opt in;
// `--brand-accent-text` is a high-contrast text color suitable on top of accent.
{
  const brand = getBrand();
  document.title = brand.pageTitle;
  const root = document.documentElement;
  root.style.setProperty('--brand-accent', brand.accentColor);
  // Provide a body-data attribute so per-brand CSS overrides are possible
  // without changing every component class.
  root.dataset.brand = brand.name.toLowerCase();
}

// Suppress Android long-press contextmenu on UI chrome (session rows, nav, FABs).
// CSS user-select:none handles iOS; contextmenu event handles Android.
// Re-allow on content areas so users can still copy message text / code.
document.getElementById('app')?.addEventListener('contextmenu', (e) => {
  const target = e.target as HTMLElement;
  if (!target.closest('.md-content, textarea, input, code, pre, [contenteditable]')) {
    e.preventDefault();
  }
});

initGoogleAuth();
render(
  <TtsProvider>
    <ReaderTtsProvider>
      <ReaderModeProvider>
        <App />
        <ReaderOverlay />
      </ReaderModeProvider>
    </ReaderTtsProvider>
  </TtsProvider>,
  document.getElementById('app')!,
);
